export const HYDRA_DOMAIN = process.env.NEXT_PUBLIC_HYDRA_DOMAIN;
export const HYDRA_CLIENT = process.env.NEXT_PUBLIC_HYDRA_CLIENT;
export const HYDRA_AUDIENCE = process.env.NEXT_PUBLIC_HYDRA_AUDIENCE;
export const API = process.env.NEXT_PUBLIC_API;
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const WEBSOCKET_URL = process.env.NEXT_PUBLIC_WEBSOCKET_URL;
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
